"use client"

import Back from "@modules/common/icons/back"
import FastDelivery from "@modules/common/icons/fast-delivery"
import Refresh from "@modules/common/icons/refresh"

import Accordion from "./accordion"
import { HttpTypes } from "@medusajs/types"

type ProductTabsProps = {
  product: HttpTypes.StoreProduct
}

const ProductTabs = ({ product }: ProductTabsProps) => {
  const tabs = [
    {
      label: "Product Description",
      // component: <ProductInfoTab product={product} />,
      component: <ProductInfoTab product={product} />,
    },
    {
      label: "Shipping Information",
      component: <ShippingInfoTab />,
    },
  ]

  return (
    <div className="w-full">
      <Accordion type="multiple">
        {tabs.map((tab, i) => (
          <Accordion.Item
            key={i}
            title={tab.label}
            headingSize="medium"
            value={tab.label}
          >
            {tab.component}
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  )
}

const ProductInfoTab = ({ product }: ProductTabsProps) => {
  return (
    // <div className="text-small-regular py-8">
    //   <div className="grid grid-cols-2 gap-x-8">
    //     <div className="flex flex-col gap-y-4">
    //       <div>
    //         <span className="font-semibold">Material</span>
    //         <p>{product.material ? product.material : "-"}</p>
    //       </div>
    //       <div>
    //         <span className="font-semibold">Country of origin</span>
    //         <p>{product.origin_country ? product.origin_country : "-"}</p>
    //       </div>
    //       <div>
    //         <span className="font-semibold">Type</span>
    //         <p>{product.type ? product.type.value : "-"}</p>
    //       </div>
    //     </div>
    //     <div className="flex flex-col gap-y-4">
    //       <div>
    //         <span className="font-semibold">Weight</span>
    //         <p>{product.weight ? `${product.weight} g` : "-"}</p>
    //       </div>
    //       <div>
    //         <span className="font-semibold">Dimensions</span>
    //         <p>
    //           {product.length && product.width && product.height
    //             ? `${product.length}L x ${product.width}W x ${product.height}H`
    //             : "-"}
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="text-small-regular py-4">

      {product.description && (
        <p>
          {product.description}
        </p>
      )}
    </div>

  )
}

const ShippingInfoTab = () => {
  return (
    <div className="text-small-regular py-8">
      <div className="grid grid-cols-1 gap-y-8">
        <div className="flex items-start gap-x-2">
          <FastDelivery />
          <div>
            <span className="font-semibold">Complimentary shipping</span>
            <p className="max-w-sm">
              Every order is delivered free, because luxury should feel effortless.
            </p>


          </div>
        </div>
        <div className="flex items-start gap-x-2">
          <FastDelivery />
          <div>
            <span className="font-semibold">Fast delivery</span>
            <p className="max-w-sm">
              Your package will arrive in 5-7 business days at your pick up
              location or in the comfort of your home.
            </p>
          </div>
        </div>
        {/* <div className="flex items-start gap-x-2">
          <Back />
          <div>
            <span className="font-semibold">Easy returns</span>
            <p className="max-w-sm">
              Just return your product and we&apos;ll refund your money. No
              questions asked – we&apos;ll do our best to make sure your return
              is hassle-free.
            </p>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default ProductTabs
